import { HttpErrorResponse } from "@angular/common/http"
import { AssessmentProfileResult } from "src/app/_models/AssessmentProfileResultDto"

export interface AssessmentProfileState {
  assessmentProfileResult: AssessmentProfileResult,
  assessmentProfileLoader: boolean,
  assessmentProfileError: HttpErrorResponse,
}

export const initialAssessmentProfileState : AssessmentProfileState = {
  assessmentProfileResult: null,
  assessmentProfileLoader: false,
  assessmentProfileError: null,
}